"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationError = void 0;
const is_error_1 = require("./is-error");
const error_codes_1 = require("../lib/error-codes");
const args_1 = require("../lib/args");
/**
 * When the user is not logged in and tries to perform a secured action
 *
 * If the user is logged in but is not allowed to perform the action consider using ForbiddenError
 */
class AuthorizationError extends is_error_1.IsError {
    constructor(messageOrError, errorOrArgs, args) {
        const { message, originalError, errorArgs } = (0, args_1.readErrorArgs)(messageOrError, errorOrArgs, args);
        super(error_codes_1.StatusErrorCode.UNAUTHORIZED, AuthorizationError.name, message, errorArgs?.reasonCode || error_codes_1.ErrorGenericReasonCode.UNAUTHORIZED, errorArgs?.userMessage || error_codes_1.ErrorMessage.UNAUTHORIZED, originalError, errorArgs);
    }
}
exports.AuthorizationError = AuthorizationError;
